import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { NotificationAccordionSettingsControllerSendTestNotificationParameter } from '../parameters/notification-accordion-settings-controller-send-test-notification.parameter';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'service-shared-features',
    operationId: 'NotificationAccordionSettingsController_sendTestNotification',
    operation: '{"operationId":"NotificationAccordionSettingsController_sendTestNotification","parameters":[{"name":"uuid","required":true,"in":"path","schema":{"type":"string"}}],"responses":{"200":{}},"method":"get","path":"/notification-accordion/{uuid}/settings/send-test-notification"}'
  })
export class NotificationAccordionSettingsControllerSendTestNotificationRemoteMethod extends OpenApiRemoteMethod<void, NotificationAccordionSettingsControllerSendTestNotificationParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<NotificationAccordionSettingsControllerSendTestNotificationParameter, void>): Promise<void> {
    return super.call(parameters);
  }
}
